import { type ReactElement, useEffect } from 'react'
import { useRouter } from 'next/router'
import Head from 'next/head'
import Link from 'next/link'
import { useSnapshot } from 'valtio'
import Breadcrumbs from '../../../../../../shared/components/ui/breadcrumbs/Breadcrumbs'
import { APP_TRANSACTIONS_PATH } from '../../../../../../pages/app/transactions'
import { buildAppTransactionPath } from '../../../../../../pages/app/transactions/[id]'
import { PageHeading } from '../../../../../../shared/components/ui/headings/PageHeading'
import Success from '../../../../../../shared/components/ui/Success'
import { NormalLink } from '../../../../../../shared/components/ui/links/NormalLink'
import { determineBrowserTabName } from '../../../../../../shared/themes/logoFunctions'
import { proxyRefund, resetProxyRefund } from './refundProxy'
import { executeTransactionRetrieveForRefund } from './executeTransactionRetrieveForRefund'
import { RefundForm } from './RefundForm/RefundForm'

export function Container (): ReactElement | null {
  const router = useRouter()
  const { id } = router.query
  const { completed } = useSnapshot(proxyRefund)

  useEffect(() => {
    if (!id) { return }
    void executeTransactionRetrieveForRefund(id as string)
  }, [id])
  useEffect(() => resetProxyRefund, [])
  if (!id) { return null }
  const transactionPath = buildAppTransactionPath(id as string)

  return (
    <>
      <Head>
        <title>{`Create Refund for Transaction ${id as string} - ${determineBrowserTabName()}`}</title>
      </Head>

      <Breadcrumbs breadcrumbs={[
        { path: APP_TRANSACTIONS_PATH, text: 'Transactions' }, { text: (id as string) }, { text: 'Create Refund' }
      ]}
      />
      <PageHeading text="Create Refund" />
      {completed
        ? (
          <>
            <Success message="Refund Completed" />
            <div className="flex justify-center">
              <NormalLink text="Continue" href={transactionPath} />
            </div>
          </>
          )
        : (
          <>
            <Link href={transactionPath}>
              <div className="underline my-6">
                {'< '}
                Back to Transaction
              </div>
            </Link>
            <RefundForm />
          </>
          )}
    </>
  )
}
